import { useQuery } from '@tanstack/vue-query';

import { API_QUERY_KEY_USER_ME } from '@/constants/api-query-key-constants';
import { useAuth } from '@/hooks/auth/use-auth';
import { useApi } from '@/hooks/use-api';
import type ApiError from '@/models/api/api-error';
import { type User } from '@/schemas/users/user-schema.ts';

// XXX: We need this hook to for users/me call at least once to sync backend / frontend authentication state
export function useAuthCheck() {
  const api = useApi();
  const { login, identifyUserOnVendorServices, logout } = useAuth();

  useQuery({
    queryKey: [API_QUERY_KEY_USER_ME],
    queryFn: async () => {
      try {
        const response = await api.get<User>('/users/me');
        const user = response.data;
        identifyUserOnVendorServices(user);
        await login();
        return user;
      } catch (error) {
        await logout();
        throw error as ApiError;
      }
    },
  });
}
